module.exports = __webpack_public_path__ + "img/awards_image_15.537f576c.jpg";